import {
  CardStyleInterpolators,
  createStackNavigator,
} from "@react-navigation/stack";
import {
  AuthorizedAppRootScreenParamList,
  OnboardingScreenParamList,
} from "../../../types";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { OnBoardingSelectCountryScreen } from "./OnBoardingSelectCountryScreen";
import { useCurrentVendorProvider } from "../../../utilities/vendor";
import { OnboardingForm } from "../components";
import { useGlobalSettingsProvider } from "../../../utilities/global-settings/hooks";
import { Colors, Spacings } from "react-native-ui-lib";
import {
  ModalCloseButton,
  TextButton,
  useWithAppState,
} from "@towersystems/roam-common-native";
import { t } from "i18next";
import { useDatabase } from "@nozbe/watermelondb/hooks";
import { useAuthenticationProvider } from "@towersystems/roam-common-native/lib/utilities/authentication";
import React from "react";
import { OnboardingConfirmDetailsScreen } from "./OnboardingConfirmDetailsScreen";

const Stack = createStackNavigator<OnboardingScreenParamList>();

export type OnboardingRootScreenProps = NativeStackScreenProps<
  AuthorizedAppRootScreenParamList,
  "OnboardingRootScreen"
>;

export const OnboardingRootScreen = () => {
  const { currentVendor } = useCurrentVendorProvider();
  const globalSettings = useGlobalSettingsProvider();
  const database = useDatabase();
  const authentication = useAuthenticationProvider();
  const { updateAppState } = useWithAppState();

  const resetAndLogoutFn = React.useCallback(() => {
    database
      .write(async () => {
        return database
          .unsafeResetDatabase()
          .catch((err) => console.log("FAILED TO RESET DB", err));
      })
      .then((i) => {
        authentication.logout();
        updateAppState({ terminalId: null, locationId: null });
      });
  }, [authentication]);

  return (
    <OnboardingForm
      defaultFormValues={{
        countryType: currentVendor.countryType,
        taxNumber: globalSettings.abn ?? "",
        businessName: globalSettings.businessName ?? "",
        website: globalSettings.website ?? "",
        emailAddress: globalSettings.email ?? "",
        phoneNumber: globalSettings.phone ?? "",
      }}
    >
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          headerStyle: {
            backgroundColor: Colors.surface,
            borderBottomWidth: 1,
            borderBottomColor: Colors.borderColor,
          },
          cardStyle: { backgroundColor: Colors.surface, height: "100%" },
          title: "Onboarding",
          headerTitleAlign: "center",
          headerTitleStyle: {
            color: Colors.text,
          },
          headerLeftContainerStyle: { paddingLeft: Spacings.s5 },
          headerRightContainerStyle: { paddingRight: Spacings.s5 },
          headerRight: () => (
            <TextButton onPress={resetAndLogoutFn}>
              {t("common:logout")}
            </TextButton>
          ),
        }}
      >
        <Stack.Screen
          name="OnBoardingSelectCountryScreen"
          component={OnBoardingSelectCountryScreen}
        />
        <Stack.Screen
          options={{
            headerLeft: () => <ModalCloseButton type="Back" />,
          }}
          name="OnboardingConfirmDetailsScreen"
          component={OnboardingConfirmDetailsScreen}
        />
      </Stack.Navigator>
    </OnboardingForm>
  );
};
